import { commonConfig } from './common';

export const environment = {
    ...commonConfig,
    authContextId: '6065',
    envName: 'nightly',
    production: false,
    rbsConfig: {
        clientId: 'lJEsPqfPnFZ0zdTlPBDptA1rfwL3GR6l',
        grant_type: 'custom_castgc',
        scope: 'rbs',
    },
    // end lst-auth library required properties
    baseUrl: 'https://stage-google-class.savvasrealizedev.com/google/class/standalone',
    googleUserUrl: 'https://stage.google-user-webapp.savvasrealizedev.com',
    classSyncUrl: 'https://class-sync-service.nightly.savvasrealizedev.com/graphql',
    classMappingUrl: 'https://stage-class-mapping-service.savvasrealizedev.com/graphql',
};
